import React from 'react';

import { ListControlProps } from './ListControl.interfaces';
import {
  RadioGroupControl,
  SelectControl,
  SelectWithFilterControl,
} from 'app/components/Controls';
import { useListControl } from 'app/shared/hooks/controls/useListControl';

export default function ListControl(props: ListControlProps) {
  const {
    isMobile,
    handleClick,
    shouldDisplayRadioGroup,
    shouldDisplaySingleOption,
  } = useListControl(props);

  const ListControlComponent: React.ElementType =
    shouldDisplayRadioGroup() && !shouldDisplaySingleOption()
      ? RadioGroupControl
      : isMobile
      ? SelectControl
      : SelectWithFilterControl;

  return (
    <ListControlComponent {...props} onClick={handleClick} native={isMobile} />
  );
}
